import { Card, Icon } from "@/components/atoms";
import { BookingDetails } from "@/redux/slices/booking/types";
import { DetailField } from "../../../../common/DetailField";

interface CompanyCardProps {
  booking: BookingDetails;
}

export const CompanyCard = ({ booking }: CompanyCardProps) => {
  const { account } = booking;
  const companyName = account?.company?.name ?? undefined;

  return (
    <Card className="p-2.5">
      <DetailField
        key="company"
        leading={<Icon name="Buildings" size="lg" className="text-neutral-dark-gray" />}
        label="Company"
        value={companyName || "-"}
      />
    </Card>
  );
};
